export const getCurrentUser = (state) => state.user.currentUser;

export default {
  getCurrentUser,
};
